class Newsletter {
  constructor() {
    const newsletterForms = document.querySelectorAll('form[id^="newsletter-form"]');
    [].forEach.call(newsletterForms, (form) => this.validationForm(form));

    if (document.querySelector('.path-inscription-newsletter')) {
      document.querySelector('#edit-statut').addEventListener('change', function (ev) {
        const value = ev.target.value;
        const nbEnf = document.querySelector('#edit-nbenfants');
        if (value === 'adherent' || value === 'parent') {
          nbEnf.options[0].style.display = "none";
          nbEnf.value === '0' && (nbEnf.value = '1');
        }
        else {
          nbEnf.options[0].style.display = "";
        }
      })
    }
  }

  validationForm(form) {
    $(form).validationEngine('attach', {promptPosition: 'topLeft', scroll: false});
  }
}

export default Newsletter
